export const pageSizeOptions = [10, 25, 30, 50];
export const statusOptions = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Open",
      value: "Ideal",
    },
    {
      label: "Open For Betting",
      value: "OpenForBetting",
    },
    {
      label: "Completed",
      value: "Closed",
    },
  ];

const APP_TYPE_VALUES = {
  WEDDING: 1,
  GUESS_THE_BABY: 2,
};

// Display names from Mobile/five_on/customization/appConfigs.js appTypeVariants
const FIVE_ON_VARIANT_NAMES = {
  3: "Golf Outing",
  4: "Bachelorette Party",
  5: "Bachelor Party",
  6: "Company Offsite",
  7: "Birthday Party",
  8: "Custom Event",
};

const appTypeBadgeList = [
  { value: APP_TYPE_VALUES.WEDDING, name: "Wedding Bets", color: "#142567", icon: "💒" },
  { value: APP_TYPE_VALUES.GUESS_THE_BABY, name: "Guess The Baby", color: "#7662B2", icon: "👶" },
  ...Object.entries(FIVE_ON_VARIANT_NAMES).map(([val, name]) => ({
    value: parseInt(val, 10),
    name,
    color: "#8DC4A9",
    icon: "🎲",
  })),
];

const appTypeBadgeByValue = appTypeBadgeList.reduce((acc, badge) => {
  acc[badge.value] = badge;
  return acc;
}, {});

const normalizeProductId = (productId) => (productId || "").toLowerCase();

// Value sent to API for "All Five On" filter (backend treats this as app_type >= 3)
export const APP_TYPE_FIVE_ON_ALL = "3plus";

// Explicit list so the Type dropdown always shows all options (All, BOTW, GTB, All Five On, then each Five On variant)
export const appTypeOptions = [
  { label: "All", value: "" },
  { label: appTypeBadgeByValue[APP_TYPE_VALUES.WEDDING].name, value: APP_TYPE_VALUES.WEDDING },
  { label: appTypeBadgeByValue[APP_TYPE_VALUES.GUESS_THE_BABY].name, value: APP_TYPE_VALUES.GUESS_THE_BABY },
  { label: "All Five On", value: APP_TYPE_FIVE_ON_ALL },
  { label: FIVE_ON_VARIANT_NAMES[3], value: 3 },
  { label: FIVE_ON_VARIANT_NAMES[4], value: 4 },
  { label: FIVE_ON_VARIANT_NAMES[5], value: 5 },
  { label: FIVE_ON_VARIANT_NAMES[6], value: 6 },
  { label: FIVE_ON_VARIANT_NAMES[7], value: 7 },
  { label: FIVE_ON_VARIANT_NAMES[8], value: 8 },
];

export const appTypeBadges = appTypeBadgeList;

const FIVE_ON_GENERIC_BADGE = { name: "Five On", color: "#8DC4A9", icon: "🎲" };

export const getAppTypeDisplayName = (appType) => {
  if (appType == null || appType === "") return "";
  const badge = appTypeBadgeByValue[parseInt(appType, 10)];
  return badge ? badge.name : String(appType);
};

export const getAppInfoFromProductId = (productId) => {
  const normalized = normalizeProductId(productId);
  if (normalized.includes("fiveon")) {
    return FIVE_ON_GENERIC_BADGE;
  }
  if (normalized.includes("_gtb")) {
    return appTypeBadgeByValue[APP_TYPE_VALUES.GUESS_THE_BABY];
  }
  return appTypeBadgeByValue[APP_TYPE_VALUES.WEDDING];
};